import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getPartnerSplitSupplyNotice,
  savePartnerSplitSupplyNoticeValues,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 他社の通告値の手直し (登録の全地点の 48 コマの上書き) mutation hook。
 * 成功したら詳細 (最終更新が新しくなる) を最新化する。 一覧は値を出さないので触らない。
 */
export function useSavePartnerSplitSupplyNoticeValues(): InvalidatingMutationResultFor<
  typeof savePartnerSplitSupplyNoticeValues
> {
  return useInvalidatingMutation(savePartnerSplitSupplyNoticeValues, [
    createConnectQueryKey({
      schema: getPartnerSplitSupplyNotice,
      cardinality: 'finite',
    }),
  ])
}
